export default (that) => [
  {
    field: 'seq',
    width: 50,
    align: 'center',
    fixed: 'left',
    type: 'seq',
  },
  {
    field: 'checkbox',
    width: 40,
    align: 'center',
    fixed: 'left',
    type: 'checkbox',
  },
  {
    field: 'defaultImageUrl',
    width: 100,
    title: that.$l('INDEX.table_label_image') || '图片',
    headerAlign: 'left',
    align: 'center',
    fixed: 'left',
    slots: { default: 'defaultImageUrl' },
  },
  {
    title: that.$l('INDEX.amz_sku_inv_goodsName') || '产品',
    field: 'goodsName',
    minWidth: 300,
    fixed: 'left',
    headerAlign: 'left',
    align: 'left',
    showHeaderOverflow: true,
    slots: { default: 'displayName' },
  },
  {
    title: that.$l('INDEX.amz_sku_inv_scmName') || '工厂',
    field: 'scmName',
    minWidth: 260,
    headerAlign: 'left',
    align: 'left',
    showHeaderOverflow: true,
    slots: { default: 'displayScmName' },
  },
  {
    title: that.$l('form_label_locationNo') || '厂库库位',
    field: 'locationNo',
    minWidth: 260,
    headerAlign: 'left',
    align: 'left',
    showHeaderOverflow: true,
    slots: { default: 'displayLocationNo' },
  },

  {
    title: that.$l('table_label_modifyByName') || '操作人',
    field: 'modifyByName',
    minWidth: 150,
    headerAlign: 'left',
    align: 'left',
    showHeaderOverflow: true,
  },

  {
    title: that.$l('table_label_modifyBillNo') || '业务单编号',
    field: 'modifyBillNo',
    minWidth: 140,
    headerAlign: 'left',
    align: 'left',
    showHeaderOverflow: true,
  },
  {
    title: that.$l('table_label_modifyDescription') || '业务类型',
    field: 'modifyDescription',
    minWidth: 150,
    headerAlign: 'left',
    align: 'left',
    showHeaderOverflow: true,
  },
  {
    title: that.$l('table_label_changeQty') || '变动数量',
    field: 'changeQty',
    minWidth: 100,
    headerAlign: 'left',
    align: 'left',
    showHeaderOverflow: true,
    formatter: ({ cellValue }) =>
      !cellValue
        ? cellValue
        : cellValue.toLocaleString(undefined, { minimumFractionDigits: 2 }),
  },
  {
    title: that.$l('table_label_ftyPrice') || '变动单价',
    field: 'ftyPrice',
    minWidth: 80,
    headerAlign: 'left',
    align: 'left',
    showHeaderOverflow: true,
    formatter: ({ cellValue }) =>
      !cellValue
        ? cellValue
        : cellValue.toLocaleString(undefined, { minimumFractionDigits: 2 }),
  },

  {
    title: that.$l('INDEX.amz_sku_inv_inCtnQty') || '箱入数',
    field: 'inCtnQty',
    minWidth: 60,
    headerAlign: 'left',
    align: 'left',
    showHeaderOverflow: true,
    formatter: ({ cellValue }) =>
      !cellValue
        ? cellValue
        : cellValue.toLocaleString(undefined, { minimumFractionDigits: 2 }),
  },
  {
    title: that.$l('INDEX.amz_sku_inv_ctnQty') || '箱数',
    field: 'changeCtnQty',
    minWidth: 90,
    headerAlign: 'left',
    align: 'left',
    showHeaderOverflow: true,
    formatter: ({ cellValue }) =>
      !cellValue
        ? cellValue
        : cellValue.toLocaleString(undefined, { minimumFractionDigits: 2 }),
  },
  {
    title: that.$l('table_label_changeAmount') || '变动金额',
    field: 'changeAmount',
    minWidth: 100,
    headerAlign: 'left',
    align: 'left',
    showHeaderOverflow: true,
    formatter: ({ cellValue }) =>
      !cellValue
        ? cellValue
        : cellValue.toLocaleString(undefined, { minimumFractionDigits: 2 }),
  },
  {
    title: that.$l('table_label_logTime') || '变动时间',
    field: 'logTime',
    minWidth: 150,
    headerAlign: 'left',
    align: 'left',
    showHeaderOverflow: true,
  },
  {
    title: that.$l('table_label_buyer_name') || '采购人员',
    field: 'buyerName',
    minWidth: 150,
    headerAlign: 'left',
    align: 'left',
    showHeaderOverflow: true,
  },
]
